import MaiaFilledIconButton from './buttons/MaiaFilledIconButton';
import { EditNote } from '@mui/icons-material';
import * as React from 'react';

export function NewTextNoteButton ({ onClick }) {
  return <MaiaFilledIconButton
    icon={EditNote}
    title={'Nueva nota'}
    onClick={onClick}
  />;
}